import { FC, PropsWithChildren } from "react";
import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import { PageNames } from "./constValues";
import { clientConfig } from "./configService";

//The userPermissions from useUserPermissionsContext will only be changed when user log in or log out.
interface PermissionProps {
    pageName?: PageNames,
    requestedPermission: string,
    renderError?: JSX.Element
}


export const PermissionsGate: FC<PropsWithChildren<PermissionProps>> = ({ children, pageName, requestedPermission, renderError = <></> }): JSX.Element => {
    const { isAuthenticated } = useOidc();
    const { accessTokenPayload } = useOidcAccessToken();

    // If a pageName is provided, check if it requires authentication based on client config
    if (pageName) {
        const registeredPages = clientConfig?.CONTENT?.REGISTERED_USERS_PAGES || [];
        const isRegisteredPage = registeredPages.some(
            (page) => page.PageName.toLowerCase() === pageName.toLowerCase()
        );

        // If the page is not in the registered users list, allow access without auth
        if (!isRegisteredPage) {
            return <>{children}</>;
        }
    }

    if (!isAuthenticated ||
            (isAuthenticated &&
                (accessTokenPayload.force_password_change === 'true' ||
                 accessTokenPayload.has_security_question === 'false' ||
                 accessTokenPayload.email_verified === 'false'
                )
        )
    ) {
        return <>{renderError}</>
    }
    return <>{children}</>;
}
